import { createFileRoute } from "@tanstack/react-router";
import { Ledger } from "@/components/Ledger";

function RouteComponent() {
  return <Ledger />;
}

export const Route = createFileRoute("/_authenticated/ledger/")({
  component: RouteComponent,
  staticData: { page: ["deals", "tax"] },
});
